module.exports = __webpack_public_path__ + "static/Roboto-Regular-subset-5780f9f36ad7b5069b8e568eed62e280.woff";